import { BankType } from '../../../generated/graphql';

export const EXCLUDED_BANK_LOGOS: { [key in BankType]?: boolean } = { };
